export const paths = {
    HOME: "/",
    INVITE_ROOM: "/:game/:roomId",
    TICTACTOE: "/tictactoe",
    CHESS: "/chess"
}